import http from '../plugins/axios'
import url from './url'

export default {
  // npxsxemluckydex 项目
  // 获取首页信息
  getData () { return http.get(url.npxsxemluckydex + 'home') },
  // 获取首页信息
  getLevelHash (data) { return http.get(url.npxsxemluckydex + 'levelHash', { params: data }) },
  // 查询hash是否中奖
  getQueryHash (data) { return http.get(url.npxsxemluckydex + 'queryHash', { params: data }) }
}
